// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"618aa4b175b10c7a2f5d","655":"86eb9748352aa2545418"}[chunkId] + ".js";
};